<template>
  <div id="faq-section" class="tw-px-4 lg:tw-px-20 tw-my-14 lg:tw-my-24">
    <div class="tw-mb-12">
      <ul class="tw-hidden lg:tw-flex tw-justify-between tw-mb-20">
        <li
          class="tw-text-2xl tw-font-semibold tw-text-black-light tw-cursor-pointer tw-bg-gray-lightest tw-py-4 tw-px-8 tw-rounded"
          :class="{ 'tw-text-primary': dealroomFocus }"
          @click="switchFaqs('dealrooms')"
        >
          Dealrooms
        </li>
        <li
          class="tw-text-2xl tw-font-semibold tw-text-black-light tw-cursor-pointer tw-bg-gray-lightest tw-py-4 tw-px-8 tw-rounded"
          :class="{ 'tw-text-primary': syndicateFocus }"
          @click="switchFaqs('syndicate')"
        >
          Syndicates/VCs
        </li>
        <li
          class="tw-text-2xl tw-font-semibold tw-text-black-light tw-cursor-pointer tw-bg-gray-lightest tw-py-4 tw-px-8 tw-rounded"
          :class="{ 'tw-text-primary': spvFocus }"
          @click="switchFaqs('spv')"
        >
          SPVs
        </li>
        <li
          class="tw-text-2xl tw-font-semibold tw-text-black-light tw-cursor-pointer tw-bg-gray-lightest tw-py-4 tw-px-8 tw-rounded"
          :class="{ 'tw-text-primary': companiesFocus }"
          @click="switchFaqs('companies')"
        >
          Companies/Startups
        </li>
      </ul>
      <div class="mobile-tab tw-relative tw-mb-20 lg:tw-mb-0">
        <select
          class="tw-w-full lg:tw-hidden tw-font-semibold tw-bg-gray-lightest tw-rounded-lg tw-border-0 tw-py-6 tw-pl-6"
          name="mobileTab"
          id="active-tab"
          @input="setFaq"
        >
          <option
            v-for="link in links"
            :key="link.label"
            :label="link.label"
            :value="link.value"
          >
            {{ link.label }}
          </option>
        </select>
        <img
          src="@/assets/img/chevron-down.svg"
          class="tw-absolute lg:tw-hidden tw-top-8 tw-right-10"
          alt="chevron icon"
        />
      </div>
      <h3 class="tw-hidden lg:tw-flex tw-text-2xl tw-font-semibold lg:tw-px-8">
        {{ title }}
      </h3>
    </div>
    <div
      v-for="faq in faqs"
      :key="faq.qestion"
      class="tw-rounded tw-border tw-border-solid tw-border-gray tw-p-4 tw-my-6 tw-cursor-pointer"
      :class="{ 'tw-border-primary': faq.open }"
      @click="faq.open = !faq.open"
    >
      <h3
        class="tw-flex tw-justify-between tw-text-base md:tw-text-lg tw-font-semibold tw-mb-4"
      >
        <span class="tw-pr-4">{{ faq.question }}</span>
        <img v-if="!faq.open" src="@/assets/img/plus.svg" alt="plus" />
        <img v-if="faq.open" src="@/assets/img/minus.svg" alt="minus" />
      </h3>
      <transition
        name="dropdown"
        @enter="enter"
        @after-enter="afterEnter"
        @leave="leave"
      >
        <p
          v-html="faq.answer"
          v-show="faq.open"
          class="tw-text-black-light tw-text-base"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import allFaqs from "@/utils/json/faqs.json";

export default {
  name: "FaqSection",

  data() {
    return {
      faqs: [],
      title: "",
      dealroomFocus: false,
      syndicateFocus: false,
      spvFocus: false,
      companiesFocus: false,
      links: [
        { label: "Dealrooms", value: "dealrooms" },
        { label: "Syndicates/VCs", value: "syndicate" },
        { label: "SPVs", value: "spv" },
        { label: "Companies/Startups", value: "companies" },
      ],
    };
  },

  mounted() {
    this.switchFaqs("dealrooms");
  },

  methods: {
    setFaq(event) {
      let faq = event.target.options[event.target.options.selectedIndex].value;
      this.switchFaqs(faq);
    },

    switchFaqs(faqs) {
      this.dealroomFocus = false;
      this.syndicateFocus = false;
      this.spvFocus = false;
      this.companiesFocus = false;
      switch (faqs) {
        case "dealrooms":
          this.dealroomFocus = true;
          this.title = "Dealrooms";
          this.faqs = allFaqs.general;
          break;
        case "syndicate":
          this.syndicateFocus = true;
          this.title = "Syndicates/VCs";
          this.faqs = allFaqs.syndicate;
          break;
        case "spv":
          this.spvFocus = true;
          this.title = "SPVs";
          this.faqs = allFaqs.spv;
          break;
        case "companies":
          this.companiesFocus = true;
          this.title = "Companies/Startups";
          this.faqs = allFaqs.companies;
          break;

        default:
          break;
      }
    },

    enter(element) {
      element.style.height = "auto";
      let height = getComputedStyle(element).height;
      element.style.height = 0;
      getComputedStyle(element);
      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    },
    leave(element) {
      element.style.height = getComputedStyle(element).height;
      getComputedStyle(element);
      setTimeout(() => {
        element.style.height = 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#faq-section {
  .dropdown-enter-active,
  .dropdown-leave-active {
    transition: height 0.3s ease-in-out;
    overflow: hidden;
  }

  @media screen and (min-width: 1024px) {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
